import { CachedModelLoader } from 'lib/CachedModelLoader';
import { WartsilaEnrichmentsResponse, WartsilaEnrichmentsResponseOptions } from 'data/models/WartsilaEnrichmentsResponse';

import { PCCache } from 'data/PCCache';

import { WartsilaEnrichmentsEstimateDetails, WartsilaEnrichmentsEstimateDetailsParams } from './estimateDetails';
import { WartsilaEnrichmentsMap, WartsilaEnrichmentsMapParams } from './map';

export interface WartsilaEnrichmentsParams {
    id: number;
}

export type WartsilaEnrichments = ReturnType<typeof WartsilaEnrichments>;
export function WartsilaEnrichments(
    loader : CachedModelLoader<WartsilaEnrichmentsResponse, WartsilaEnrichmentsResponseOptions>,
    data : PCCache,
    estimateDetailsModel : (params : WartsilaEnrichmentsEstimateDetailsParams) => WartsilaEnrichmentsEstimateDetails,
    mapModel : (params : WartsilaEnrichmentsMapParams) => WartsilaEnrichmentsMap,
    { id } : WartsilaEnrichmentsParams
) {
    const { model, loading: modelLoading, task } = loader({ Id: id }, 120),
        portcall = data.PortCalls.update1(null, { Id: id }),
        estimateDetails = estimateDetailsModel({ model, readyForInitialRefresh: task }),
        map = mapModel({ model });

    return {
        PortCall: portcall,
        EstimateDetails: estimateDetails,
        Map: map,
        Loading: () => modelLoading() || estimateDetails.AnyRefreshPendingOrInProgress()
    };
}



// WEBPACK FOOTER //
// ./apps/wartsila/wartsilaenrichments/model.ts